import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const User: IModel = {
  title: "LDT",
  apiPath: "ldt",
  forms : {
    "default": {
      fields: ["id", "naziv"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "naziv"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    commonFields.owner_organisation,
    commonFields.data_source,
    coreFields.active,
    {
      title: "Naziv",
      source: "naziv",
      ttoken: "staze.naziv",
      type: "text",
      validation: {
        maxLength: 254
      },
      width: "full"
    },
    {
      title: "Naziv token",
      source: "naziv_ttoken",
      ttoken: "staze.naziv_ttoken",
      type: "text",
      validation: {
        maxLength: 254
      },
      width: "full"
    },
    {
      title: "duljina_m",
      source: "duljina_m",
      ttoken: "staze.duljina",
      type: "wholenum",
      suffix: "m",
      readonly: true
    },
    {
      title: "delta_h_m",
      source: "delta_h_m",
      ttoken: "staze.delta_h",
      type: "wholenum",
      suffix: "m",
      readonly: true
    },
    {
      title: "vrijeme_min",
      source: "vrijeme_min",
      ttoken: "staze.vrijeme",
      type: "wholenum",
      suffix: "min",
      // tooltip:"staze.vrijeme_tooltip",
    },
    {
      title: "vrijeme_hhmm",
      source: "vrijeme_hhmm",
      ttoken: "staze.vrijeme",
      type: "text",
      validation: {
        maxLength: 5
      },
      tooltip:"staze.vrijeme_tooltip",
      readonly: true
    },
    coreFields.created_on,
    commonFields.wkt,
    {
      title: "info url",
      source: "info_url",
      ttoken: "data.info_url",
      type: "url",
      width: "full",
      readonly: true,
    },
    {
      title: "Dijelovi",
      source: "stages",
      ttoken: "staze.stages",
      type: "array"
    },
    {
      title: "Highlight color",
      source: "highlight_color",
      ttoken: "staze.highlight_color",
      type: "text"
    }
  ]
}

export default User;
